export const average = (dataset: Array<number>): number => {
	const values = [];

	dataset.forEach((set) => {
		values.push(set?.data.reduce((a, b) => parseFloat(a) + parseFloat(b), 0) / set?.data.length);
	});

	return values.reduce((a, b) => a + b, 0) / values.length;
};
